import { AgeRestriction } from '@diritto/common/content/constants';
import { useMemo } from 'react';
import { UP_EPISODE_TIME } from '@diritto/common/episode/constants';
import { EpisodePublicRelayDto } from '@diritto/common/relay/dtos/episode-relay.dtos';

export const useEpisodeState = (episode: EpisodePublicRelayDto, isAdultContent: boolean) => {
  const isAdult = useMemo(() => episode.ageRestriction === AgeRestriction.Adult, [episode.ageRestriction]);

  const isUpdated = useMemo(() => {
    const now = new Date();
    return episode.firstOpenedAt ? new Date(episode.firstOpenedAt).getTime() >= now.getTime() - UP_EPISODE_TIME : false;
  }, [episode]);

  return {
    isAdult: !isAdultContent && isAdult,
    isUpdated,
  };
};
